import template from './google-map.html';
import { dynamicMap } from './google-map.google';
import { globals } from '@updater/angular-common';
import { ENVIRONMENT } from '../../../../environment';
const CDN_URL = globals.urls.cdn;

class GoogleMapController {
  constructor(angularLoad) {
    'ngInject';
    Object.assign(this, { angularLoad });
  }

  $onInit() {
    this.load().then(() => {
      return dynamicMap(
        document.getElementById('map-canvas'),
        this.fromAddress,
        this.toAddress,
        this.showHeader,
        this.isPublic
      );
    });
  }

  load() {
    return this.angularLoad
      .loadScript(
        // Specify the release version with v=3: https://developers.google.com/maps/documentation/javascript/versions
        `//maps.googleapis.com/maps/api/js?v=3&key=${
          ENVIRONMENT.keys.googleMap
        }`
      ) // Infobox is at 1.1.13, should be stable: https://github.com/googlemaps/v3-utility-library/tree/master/infobox
      .then(() => this.angularLoad.loadScript(`${CDN_URL}/scripts/infobox.js`));
  }
}

export const GoogleMapComponent = {
  template,
  controller: GoogleMapController,
  bindings: {
    height: '@',
    width: '@',
    isPublic: '@',
    showHeader: '@',
    toAddress: '<',
    fromAddress: '<',
  },
};
